// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d44c9130","186":"4cd0c8a8","225":"11490adc","272":"4f0b4c1e","372":"123a079c","573":"4b708168","738":"6ab8a0d5","841":"c4fa27a0","856":"f0c454c4","909":"bd727e18"}[chunkId] + ".chunk.js";
};